import React from 'react'
import Layout from '../components/Layout/Layout'
import { usePutRequest } from '../hooks/request'
import { useMessage } from '../hooks/message'
import Card from '../components/common/Card'
import UserForm from '../components/Layout/UserForm'
import UserChangePassword from '../components/Layout/UserChangePassword'
import SettingsTabs from '../components/Layout/SettingsTabs'
import { CHANGE_PASSWORD, USER_SETTINGS } from '../urls'
import { checkPermission as cp } from '../utils/auth'
import { PermissionDenied } from '../components/PermissionDenied'

export default function SettingsUser() {
    const updateUserSetting = usePutRequest({ url: USER_SETTINGS })
    const changePassword = usePutRequest({ url: CHANGE_PASSWORD })
    const user = JSON.parse(localStorage.getItem('user'))
    const [showMessage] = useMessage()

    async function onSubmit(data) {
        await updateUserSetting.request({ data })
        localStorage.setItem('user', JSON.stringify(data))
        showMessage('Информация была изменена', 'is-success')
    }

    async function updatePassword(data, actions) {
        if (data.newPassword !== data.confirmPassword) {
            showMessage('Введенные пароли не совпадают', 'is-danger')
            return
        }

        const { error } = await changePassword.request({ data, newPassword: data.newPassword })
        if (error) {
            showMessage('Введите старый пароль правильно.', 'is-danger')
        } else {
            showMessage('Пароль изменен', 'is-success')
        }
        actions.resetForm()
    }
    if (!cp('READ')) {
        return <PermissionDenied />
    }
    return (
        <Layout className="has-background-light">
            <SettingsTabs />

            <div className="columns">
                <div className="column">
                    <Card>
                        <UserForm user={user} onSubmit={onSubmit} />
                    </Card>
                </div>&nbsp;

                <div className="column">
                    <Card>
                        <UserChangePassword onSubmit={updatePassword} />
                    </Card>
                </div>
            </div>
        </Layout>
    )
}
